import React from 'react'
import PropTypes from 'prop-types'
import css from './styles.scss'
import globalCss from '../../../scss/global.scss'

const ToolTip = ({ tips, minWidth }) => {
  if (!tips || tips.length === 0) {
    return null
  }
  let content = null
  let WrapElement = 'p'
  if (Array.isArray(tips)) {
    WrapElement = 'ol'
    content = tips.map((tip, i) => {
      return (
        <li key={`${tip}-${i}`}>
          {tip}
        </li>
      )
    })
  } else {
    content = tips
  }

  return (
    <div className={css.toolTip}>
      <i className={globalCss.iconHelpCircled} />
      <span className={css.toolTipText} style={{ minWidth }}>
        <div className={css.helpText}>
          <WrapElement>
            {content}
          </WrapElement>
        </div>
      </span>
    </div>
  )
}
ToolTip.defaultProps = {
  tips: [],
  minWidth: 300
}
ToolTip.propTypes = {
  tips: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.element]),
  minWidth: PropTypes.number
}
export default ToolTip



// WEBPACK FOOTER //
// /app/js/components/ToolTip/index.js